import React, { Component } from 'react';

import Navbar from './components/Nav2017';
import Hero from './components/Hero2017';
import TechStack from './components/TechStack';
import CummerbundParticles from './components/CummerbundParticles';
import Footer from './components/Footer2017';

import './App.css';

class App extends Component {
  render() {
    let Cummerbund = CummerbundParticles;
    return (
      <div className="App">
        <Navbar />
        <Hero />
        <TechStack />
        <Cummerbund />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js